import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "paymentTooltip",
  style: {"visibility":"hidden"},
  class: "divTooltip"
}
const _hoisted_2 = {
  id: "accValidTooltip",
  style: {"visibility":"hidden"},
  class: "divTooltip"
}
const _hoisted_3 = {
  id: "payValidTooltip",
  style: {"visibility":"hidden"},
  class: "divTooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "d-flex align-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_switch, {
              modelValue: _ctx.activatePayment,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activatePayment) = $event)),
              label: "Activer le paiement",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPayment())),
              class: "pa-0 pl-2"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: {"min-width":"800px"}
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "svg-container",
          id: "container"
        }, [
          _createElementVNode("svg", {
            width: "100%",
            height: "100%",
            class: "svg-content",
            preserveAspectRatio: "xMidYMid meet"
          }, [
            _createElementVNode("g")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_card, {
            class: "default_card mx-0 my-2 pa-2",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentItems, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      class: "oss-list-item",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          modelValue: _ctx.links.payment,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.links.payment) = $event)),
                          label: _ctx.$t('workflow.nodes.' + item),
                          onChange: ($event: any) => (_ctx.addEdge('payment', item)),
                          class: "pa-0 pl-2",
                          value: item
                        }, null, 8, ["modelValue", "label", "onChange", "value"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_card, {
            class: "default_card mx-0 my-2 pa-2",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accValidItems, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      class: "oss-list-item",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          disabled: !_ctx.activatePayment,
                          modelValue: _ctx.links.accountingValidation,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.links.accountingValidation) = $event)),
                          label: _ctx.$t('workflow.nodes.' + item),
                          onChange: ($event: any) => (_ctx.addEdge('accountingValidation', item)),
                          class: "pa-0 pl-2",
                          value: item
                        }, null, 8, ["disabled", "modelValue", "label", "onChange", "value"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_card, {
            class: "default_card mx-0 my-2 pa-2",
            elevation: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payValidItems, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      class: "oss-list-item",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          disabled: !_ctx.activatePayment,
                          modelValue: _ctx.links.paymentValidation,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.links.paymentValidation) = $event)),
                          label: _ctx.$t('workflow.nodes.' + item),
                          onChange: ($event: any) => (_ctx.addEdge('paymentValidation', item)),
                          class: "pa-0 pl-2",
                          value: item
                        }, null, 8, ["disabled", "modelValue", "label", "onChange", "value"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}